var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.images.length
    ? _c(
        "div",
        { staticClass: "image-slider insicht" },
        [
          _c(
            "vue-glide",
            _vm._b({ ref: "glide" }, "vue-glide", _vm.glideOptions, false),
            _vm._l(_vm.images, function(image) {
              return _c(
                "vue-glide-slide",
                { key: image.id, staticClass: "image-slider__slide" },
                [
                  _c("img", {
                    ref: "image",
                    refInFor: true,
                    staticClass: "image-slider__slide-image",
                    attrs: {
                      srcset: image.image.srcset,
                      src: image.image.src,
                      alt: image.title,
                      "data-object-fit": "",
                      loading: "lazy"
                    }
                  })
                ]
              )
            }),
            1
          )
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }